import { useState } from "react";
import { faqs } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative border-y border-background-900 bg-background-900/40 py-16 md:py-24">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="关于黑屋，你想问的都在这里"
              desc="关于内容来源、栏目划分与转载订阅的问题，我们一次讲清。"
            />
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-700 px-5 py-2.5 text-sm text-foreground-100 transition-colors hover:border-primary-500/50 hover:text-primary-300"
            >
              <i className="ri-customer-service-2-line" aria-hidden="true"></i>
              还有其他问题？联系编辑部
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-2xl border transition-colors ${
                      isOpen ? "border-accent-500/30 bg-background-950" : "border-background-800 bg-background-900/60"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                    >
                      <span className="font-serif text-base font-semibold text-foreground-100 md:text-lg">{f.q}</span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-accent-500 text-background-950" : "bg-background-800 text-foreground-300"
                        }`}
                      >
                        <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <p className="border-t border-background-800 px-5 py-4 text-sm leading-relaxed text-foreground-400 md:px-6 md:py-5">
                        {f.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;